<template>
  <div class="app-container">
    <div class="filter-container">
      <el-select v-model="listQuery.tenantId" placeholder="选择租户" clearable style="width: 200px;" class="filter-item" @change="handleFilter">
        <el-option v-for="item in tenantList" :key="item.tenantId" :label="item.name" :value="item.tenantId" />
      </el-select>
      <el-input v-model="listQuery.nickname" placeholder="用户昵称" style="width: 200px;" class="filter-item" @keyup.enter.native="handleFilter" />
      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">搜索</el-button>
    </div>

    <el-table v-loading="listLoading" :data="list" border fit highlight-current-row style="width: 100%;">
	  <el-table-column label="所属租户" prop="tenantName" align="center" width="120" />
      <el-table-column label="用户ID" prop="userId" align="center" width="80" />
      <el-table-column label="用户编号" prop="userNo" align="center" width="160" />
      <el-table-column label="OpenID" prop="openId" align="center" width="200">
        <template slot-scope="{row}">
          <span v-if="row.openId" :title="row.openId">{{ row.openId.length > 20 ? row.openId.substring(0, 20) + '...' : row.openId }}</span>
          <span v-else style="color: #999;">-</span>
        </template>
      </el-table-column>
      <el-table-column label="昵称" prop="globalNickname" align="center" width="120" />
	  <el-table-column label="手机号" prop="phone" align="center" width="120" />
      <el-table-column label="头像" prop="globalAvatarUrl" align="center" width="80">
        <template slot-scope="{row}">
          <el-avatar :src="row.globalAvatarUrl" size="small" />
        </template>
      </el-table-column>
	  <el-table-column label="性别" prop="gender" align="center" width="80">
	    <template slot-scope="{row}">
	      <span v-if="row.gender === 'male'">男</span>
	      <span v-else-if="row.gender === 'female'">女</span>
	      <span v-else>未知</span>
	    </template>
	  </el-table-column>
      <el-table-column label="标签" prop="tags" align="center">
        <template slot-scope="{row}">
          <el-tag v-for="tag in row.tags" :key="tag" style="margin-right: 5px;">{{ tag }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="黑名单" prop="isBlacklisted" align="center" width="100">
        <template slot-scope="{row}">
          <el-tag :type="row.isBlacklisted ? 'danger' : 'success'">{{ row.isBlacklisted ? '是' : '否' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="总访问次数" prop="totalVisits" align="center" width="120" />
      <el-table-column label="最后访问" prop="lastSeenAt" align="center" width="160">
        <template slot-scope="{row}">
          <span>{{ row.lastSeenAt | parseTime }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="260">
        <template slot-scope="{row}">
          <el-button type="info" size="mini" @click="handleViewDetail(row)">详情</el-button>
          <el-button type="primary" size="mini" @click="handleUpdateTags(row)">标签</el-button>
          <el-button v-if="!row.isBlacklisted" type="danger" size="mini" @click="handleAddBlacklist(row)">拉黑</el-button>
          <el-button v-else type="success" size="mini" @click="handleRemoveBlacklist(row)">解封</el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination v-show="total>0" :total="total" :page.sync="listQuery.pageNum" :limit.sync="listQuery.pageSize" @pagination="getList" />

    <el-dialog title="编辑标签" :visible.sync="tagDialogVisible">
      <el-form label-width="80px">
        <el-form-item label="用户标签">
          <el-tag
            v-for="tag in currentTags"
            :key="tag"
            closable
            @close="handleCloseTag(tag)"
            style="margin-right: 5px;"
          >
            {{ tag }}
          </el-tag>
          <el-input
            v-if="tagInputVisible"
            ref="tagInput"
            v-model="tagInputValue"
            class="input-new-tag"
            size="small"
            maxlength="10"
            show-word-limit
            @keyup.enter.native="handleInputConfirm"
            @blur="handleInputConfirm"
          />
          <el-button v-else-if="currentTags.length < 3" class="button-new-tag" size="small" @click="showTagInput">+ 新标签</el-button>
          <span v-else class="tag-limit-tip">最多3个标签</span>
        </el-form-item>
        <div class="tag-tips">提示：最多添加3个标签，每个标签不超过10个字</div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="tagDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveTags">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="加入黑名单" :visible.sync="blacklistDialogVisible">
      <el-form ref="blacklistForm" :model="blacklistForm" :rules="blacklistRules" label-width="100px">
        <el-form-item label="原因" prop="reason">
          <el-input v-model="blacklistForm.reason" type="textarea" :rows="3" />
        </el-form-item>
        <el-form-item label="过期时间" prop="expireAt">
          <el-date-picker v-model="blacklistForm.expireAt" type="datetime" placeholder="选择过期时间" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="blacklistDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmAddBlacklist">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="用户详情" :visible.sync="detailDialogVisible" width="600px">
      <el-descriptions :column="2" border>
        <el-descriptions-item label="用户ID">{{ detailData.userId }}</el-descriptions-item>
        <el-descriptions-item label="用户编号">{{ detailData.userNo }}</el-descriptions-item>
        <el-descriptions-item label="OpenID" :span="2">{{ detailData.openId || '-' }}</el-descriptions-item>
        <el-descriptions-item label="UnionID" :span="2">{{ detailData.unionId || '-' }}</el-descriptions-item>
        <el-descriptions-item label="昵称">{{ detailData.globalNickname || '-' }}</el-descriptions-item>
        <el-descriptions-item label="手机号">{{ detailData.phone || '-' }}</el-descriptions-item>
        <el-descriptions-item label="邮箱">{{ detailData.email || '-' }}</el-descriptions-item>
        <el-descriptions-item label="性别">
          <span v-if="detailData.gender === 1">男</span>
          <span v-else-if="detailData.gender === 2">女</span>
          <span v-else>未知</span>
        </el-descriptions-item>
        <el-descriptions-item label="头像" :span="2">
          <el-avatar v-if="detailData.globalAvatarUrl" :src="detailData.globalAvatarUrl" size="medium" />
          <span v-else>无</span>
        </el-descriptions-item>
        <el-descriptions-item label="标签" :span="2">
          <el-tag v-for="tag in detailData.tags" :key="tag" style="margin-right: 5px;">{{ tag }}</el-tag>
          <span v-if="!detailData.tags || detailData.tags.length === 0">无</span>
        </el-descriptions-item>
        <el-descriptions-item label="黑名单">
          <el-tag :type="detailData.isBlacklisted ? 'danger' : 'success'">{{ detailData.isBlacklisted ? '是' : '否' }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="拉黑原因" v-if="detailData.isBlacklisted">{{ detailData.blacklistReason || '-' }}</el-descriptions-item>
        <el-descriptions-item label="拉黑过期" v-if="detailData.isBlacklisted">{{ detailData.blacklistExpireAt | parseTime }}</el-descriptions-item>
        <el-descriptions-item label="总访问次数">{{ detailData.totalVisits || 0 }}</el-descriptions-item>
        <el-descriptions-item label="首次访问">{{ detailData.firstSeenAt | parseTime }}</el-descriptions-item>
        <el-descriptions-item label="最后访问">{{ detailData.lastSeenAt | parseTime }}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ detailData.createdAt | parseTime }}</el-descriptions-item>
        <el-descriptions-item label="更新时间">{{ detailData.updatedAt | parseTime }}</el-descriptions-item>
      </el-descriptions>
      <div slot="footer" class="dialog-footer">
        <el-button @click="detailDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listTenantUsers, getTenantUser, addToBlacklist, removeFromBlacklist, updateUserTags } from '@/api/tenantUser'
import { listTenants } from '@/api/tenant'
import Pagination from '@/components/Pagination'

export default {
  name: 'TenantUserList',
  components: { Pagination },
  filters: {
    parseTime(time) {
      if (!time) return ''
      const date = new Date(time)
      return date.toLocaleString()
    }
  },
  data() {
    return {
      list: null,
      total: 0,
      listLoading: true,
      tenantList: [],
      listQuery: {
        pageNum: 1,
        pageSize: 20,
        nickname: undefined,
        tenantId: undefined
      },
      tagDialogVisible: false,
      currentUserId: null,
      currentTenantId: null,
      currentTags: [],
      tagInputVisible: false,
      tagInputValue: '',
      blacklistDialogVisible: false,
      blacklistForm: {
        reason: '',
        expireAt: null
      },
      blacklistRules: {
        reason: [{ required: true, message: '请输入拉黑原因', trigger: 'blur' }]
      },
      detailDialogVisible: false,
      detailData: {}
    }
  },
  created() {
    this.getTenantList()
    this.getList()
  },
  methods: {
    getTenantList() {
      listTenants({ pageNum: 1, pageSize: 1000 }).then(response => {
        this.tenantList = response.data.records
      })
    },
    getList() {
      this.listLoading = true
      listTenantUsers(this.listQuery).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.pageNum = 1
      this.getList()
    },
    handleViewDetail(row) {
      getTenantUser(row.userId, row.tenantId).then(response => {
        this.detailData = response.data
        this.detailDialogVisible = true
      })
    },
    handleUpdateTags(row) {
      this.currentUserId = row.tenantUserId
      this.currentTenantId = row.tenantId
      this.currentTags = row.tags || []
      this.tagDialogVisible = true
    },
    handleCloseTag(tag) {
      this.currentTags.splice(this.currentTags.indexOf(tag), 1)
    },
    showTagInput() {
      if (this.currentTags.length >= 3) {
        this.$message.warning('最多只能添加3个标签')
        return
      }
      this.tagInputVisible = true
      this.$nextTick(() => {
        this.$refs.tagInput.$refs.input.focus()
      })
    },
    handleInputConfirm() {
      const tagValue = this.tagInputValue.trim()
      if (tagValue) {
        if (tagValue.length > 10) {
          this.$message.warning('标签不能超过10个字')
          return
        }
        if (this.currentTags.length >= 3) {
          this.$message.warning('最多只能添加3个标签')
          this.tagInputVisible = false
          this.tagInputValue = ''
          return
        }
        if (this.currentTags.includes(tagValue)) {
          this.$message.warning('标签已存在')
          return
        }
        this.currentTags.push(tagValue)
      }
      this.tagInputVisible = false
      this.tagInputValue = ''
    },
    saveTags() {
      if (this.currentTags.length > 3) {
        this.$message.warning('最多只能添加3个标签')
        return
      }
      for (const tag of this.currentTags) {
        if (tag.length > 10) {
          this.$message.warning('标签不能超过10个字')
          return
        }
      }
      updateUserTags(this.currentUserId, this.currentTenantId, this.currentTags).then(() => {
        this.$message.success('标签更新成功')
        this.tagDialogVisible = false
        this.getList()
      })
    },
    handleAddBlacklist(row) {
      this.currentUserId = row.tenantUserId
      this.currentTenantId = row.tenantId
      this.blacklistForm = {
        reason: '',
        expireAt: null
      }
      this.blacklistDialogVisible = true
    },
    confirmAddBlacklist() {
      this.$refs.blacklistForm.validate(valid => {
        if (valid) {
          addToBlacklist(this.currentUserId, this.currentTenantId, this.blacklistForm).then(() => {
            this.$message.success('已加入黑名单')
            this.blacklistDialogVisible = false
            this.getList()
          })
        }
      })
    },
    handleRemoveBlacklist(row) {
      this.$confirm('确定将该用户移出黑名单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        removeFromBlacklist(row.tenantUserId, row.tenantId).then(() => {
          this.$message.success('已移出黑名单')
          this.getList()
        })
      })
    }
  }
}
</script>

<style scoped>
.filter-container {
  margin-bottom: 20px;
}
.filter-item {
  margin-right: 10px;
}
.input-new-tag {
  width: 120px;
  margin-right: 10px;
  vertical-align: bottom;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.tag-limit-tip {
  margin-left: 10px;
  color: #909399;
  font-size: 12px;
}
.tag-tips {
  color: #909399;
  font-size: 12px;
  margin-top: 10px;
}
</style>
